import axios from "axios";

import { CLIENT_ID, PROJECT_ID } from "./constants";

const baseUrl =
  "https://api.sandbox.cp.clearsense.com/ingest-interface/api/v1/";

const HEADERS = { "x-client-id": CLIENT_ID };

const uploadFile = (payload, datasetName) =>
  axios.post(`${baseUrl}files/${PROJECT_ID}`, payload, {
    headers: HEADERS,
    params: { datasetName },
  });

const fetchFiles = () =>
  axios.get(`${baseUrl}files`, {
    headers: HEADERS,
  });

const fetchDatasets = () =>
  axios.get(`${baseUrl}datasets`, {
    headers: HEADERS,
  });

const deleteFile = (datasetName, fileName) =>
  axios.delete(`${baseUrl}files/${PROJECT_ID}`, {
    headers: HEADERS,
    params: { datasetName, fileName },
  });

const IngestionApi = {
  uploadFile,
  fetchFiles,
  fetchDatasets,
  deleteFile,
};

export default IngestionApi;
